import { Input, OnChanges } from '@angular/core';
import * as debug from 'debug';
import { SocketService } from '@app/core/socket.service';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';

const log = debug('edg:reply-abstract');

export abstract class ReplyAbstractComponent implements OnChanges {
  @Input() serverSeed: string = null;
  @Input() playerSeed: string = null;
  @Input() gameId = null;

  public _loading = true;
  public _error = false;

  protected constructor(protected socket: SocketService, protected balanceHistory: BalanceHistoryService) {}

  ngOnChanges() {
    const params = {};
    if (this.gameId) {
      this._loading = true;
      this._error = false;
      params['id'] = this.gameId;

      this.balanceHistory
        .gameDetails(this.gameId)
        .then((value: any) => {
          this.initialize(value);
        })
        .catch((error: any) => {
          this._error = true;
          log(error);
        });
    } else if (this.serverSeed && this.playerSeed) {
      this._loading = true;
      this._error = false;
      this.generateGame();
    }
  }

  protected initialize(value: any) {
    log('initialize');
  }

  protected generateGame() {
    log('generate');
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-abstract.component.ts